// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"03cdcd3b","769":"ad0427b3"}[chunkId] + ".chunk.js";
};